export default {
  breadcrumb_li: {
    list_item: 'flex-wrap list-ul px-0 py-2',
    list_li: 'font-sans-bold text-grey-dark inline-block',
    list_link: 'font-sans-bold text-grey-dark inline-block text-14 md:text-12',
  },
  breadcrumbMainDiv: 'breadcrumb mx-auto px-8 lg:px-30 lg:min-h-24 min-h-25',
};
